export const HERO_TITLE = 'From 10,000 BTC for 2 pizzas to today';
export const HERO_SUBTITLE =
  "See Bitcoin's purchasing power in pizza units. Explore how many pizzas one BTC buys, compare pricing models, and inspect every assumption in plain English.";

export const HERO_CTA = 'Explore the chart';

export const METHOD_INTRO =
  'This project converts BTC/USD into pizza units. We provide a Laszlo baseline model and an inflation-adjusted yearly pizza price model for transparency.';
